import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { ALL_TIMEZONES } from '../graphql/queries/locale';
/**
 * Custom hook to fetch and retrieve all timezones.
 * @returns An object containing the list of timezones and options.
 */
export const useAllTimezones = () => {
    const { data } = useQuery(ALL_TIMEZONES, {
        fetchPolicy: 'cache-first',
    });
    const timezones = useMemo(() => data?.allTimezones || [], [data]);
    /**
     * Converts the list of timezones into an array of options.
     * @returns An array of options, each containing a value and label.
     */
    const options = useMemo(() => {
        return timezones.map(timezone => ({
            value: timezone,
            label: timezone,
        }));
    }, [timezones]);
    return { timezones, options };
};
